import { useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { CommunicationType, DirectionEnum, totalCallsMadeInCurrentDay } from 'wisestep-api';

import { useComposableDashboardsContext } from '../../../../../features/analyticsPage/hooks/useComposableDashboardsContext';
import useBulkApi from '../../../../../features/composableAnalytics/hooks/useBulkApi';
import { IMISAnalyticsQuery } from '../../IMISAnalyticsQuery';

import CustomCountWithTextCard from './CustomCountWithTextCard';

const TotalSMSSentMetric = ({ query }: IMISAnalyticsQuery) => {
  const [smsCount, setSmsCount] = useState<number>(0);
  const { fetchChartsInBulk } = useComposableDashboardsContext();
  const keyForBulkApi = useMemo(() => uuidv4(), []);
  query.direction = DirectionEnum.OUTBOUND;
  query.type = CommunicationType.SMS;
  const { response: reponseFromBulkApi } = useBulkApi(
    keyForBulkApi,
    query,
    'api/communications/total_calls_made_in_current_day',
    true
  );
  useEffect(() => {
    const fetchData = async () => {
      const response = await totalCallsMadeInCurrentDay(query);
      setSmsCount(response.data?.hits?.total ?? 0);
    };
    if (!fetchChartsInBulk?.current) fetchData();
    else reponseFromBulkApi && setSmsCount(reponseFromBulkApi?.data.hits?.total);
  }, [fetchChartsInBulk, query, reponseFromBulkApi]);

  return <CustomCountWithTextCard count={smsCount} text="Total number of SMS Sent - Life time" />;
};

export default TotalSMSSentMetric;
